<template lang="pug">
  .active-filters(v-if="activeFilters.length > 0")
    .filtered-by.font-weight-bold.font-size-s {{ __('FILTERED BY') }}
    rogue-link.active-filter.font-size-xs(
      :to="filter.clearRoute"
      v-for="filter in activeFilters"
      :key="filter.text"
    )
      Icon.icon-size-xxs(name="x")
      span(v-html="__(filter.text, 'specs')")
    rogue-link.clear-all.font-size-xs.link(:to="clearFiltersRouterLinkTo(route.query, filters)") {{ __('Clear All') }}
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import { clearFiltersRouterLinkTo } from '../helpers/index'

const route = useRoute()

const props = defineProps({
  filters: {
    type    : Object,
    default : () => ({}),
  },

  activeFilters: {
    type    : Array<{ clearRoute: { query: { [key: string]: any } }, text: string }>,
    default : () => ([]),
  },
})
</script>

<style lang="scss" scoped>
.active-filters {
  display: flex;
  align-items: center;
  border-top: $border-width-thin solid $color-gray-light;
  border-bottom: $border-width-thin solid $color-gray-light;
  flex-wrap: wrap;
  padding-top: $space-xs;
  padding-bottom: $space-xs;

  &::-webkit-scrollbar {
    display: none;
  }

  @include not-desktop() {
    flex-wrap: nowrap;
    overflow-x: scroll;
  }
}

.filtered-by,
.active-filter {
  margin-right: $space-xs;
  margin-bottom: $space-xxs;
  white-space: nowrap;
}

.active-filter {
  cursor: pointer;
  border: $border-width-thin solid $color-gray;
  display: inline-flex;
  padding: $space-xxs;
  border-radius: $radius-default;
  color: $color-black;
  align-items: center;
  text-decoration: none;

  .icon {
    margin-right: $space-xxs;
  }
}

.clear-all {
  white-space: nowrap;
}

:deep(.star, .count) {
  color: $color-gray-dark;

  &.gold {
    color: $color-yellow-dark;
  }
}
</style>
